import {IRegulationPresetValues} from '../regulation-preset-values.interface';
const overrideJson = require('json-override');

function createCommonPresetValues(): IRegulationPresetValues {
    return {
        sdk: {
            Skin: {
                regulationID: 7,
                brandID: null,
                subBrandID: null,
            },
            Currency: {
                anonymousCurrency: 'USD'
            },
            OAuth2: {
                fakeClientIP: '192.118.64.29'
            }
        },
        orbit: {
            country: 'usa',
            language: 'eng',
            iso2: 'en',
            publicationID: null,
            cmsSource: null
        }
    }
}

export const NJ888_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 73,
            subBrandID: 107,
        }
    },
    orbit: {
        publicationID: 1906,
        cmsSource: 'https://us.888casino.com'
    }
});

export const HARRAHS_NJ_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 72,
            subBrandID: 105,
        }
    },
    orbit: {
        publicationID: 1924,
        cmsSource: 'https://nj.HarrahsCasino.com'
    }
});

export const WSOP_NJ_PRESETS_VALUES: IRegulationPresetValues = overrideJson(createCommonPresetValues(), {
    sdk: {
        Skin: {
            brandID: 71,
            subBrandID: 104,
        }
    },
    orbit: {
        publicationID: 1927,
        cmsSource: 'https://casino-nj.WSOP.com'
    }
});
